/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventScreenViewedFromJSON(json) {
    return StreemApiAnalyticEventScreenViewedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventScreenViewedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'screenId': !exists(json, 'screen_id') ? undefined : json['screen_id'],
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
    };
}
export function StreemApiAnalyticEventScreenViewedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'screen_id': value.screenId,
        'room_sid': value.roomSid,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventScreenViewed.js.map